import { TrainingClearErrorsAction } from './../../store/action/TrainingActions';
import { SurveyClearErrorsAction } from './../../store/action/SurveyActions';
import { ListCollaboratorIdeasAction, IdeaClearAction, BrainstormClearErrorsAction, ListImplementerIdeasAction } from './../../store/action/BrainstormActions';
import { BrainstormPage } from './../brainstorm/brainstorm';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, ToastController, LoadingController } from 'ionic-angular';
import { Subscription } from '../../../node_modules/rxjs';
import { AppStore } from '../../store/AppStore';
import { Store } from '../../../node_modules/@ngrx/store';
import { LoginPage } from '../login/login';
import { IdeaModel } from '../../model/BrainstormModel';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { LogoutAction } from '../../store/action/UserActions';
import { CronosClearErrorsAction } from '../../store/action/CronosActions';

@IonicPage()
@Component({
  selector: 'page-brainstorm-list',
  templateUrl: 'brainstorm-list.html',
})
export class BrainstormListPage {

  public collaboratorItems: Array<IdeaModel> = [];
  public implementerItems: Array<IdeaModel> = [];
  public filteredItems: Array<IdeaModel> = [];
  public searchInput: string = null;
  public shouldShowCancelSearch: boolean = false;
  public selectedType: string = '0';
  public isLoading: boolean;
  public loader: Loading;

  private userId: number;
  private loggingOff: boolean;
  private collaboratorLoaded: boolean;
  private refresher: any = null;

  private userSubscription: Subscription;
  private brainstormSubscription: Subscription;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController
  ) {      
  }

  ionViewWillEnter() {

    this.loggingOff = false;
    this.collaboratorLoaded = false;
    
    this.isLoading = false;
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.store.dispatch(new ListCollaboratorIdeasAction({ userId: this.userId }));
      }
    });
  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (1)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewDidEnter() {

    this.brainstormSubscription = this.store.select('brainstormState').subscribe(brainstormState => {
      if ((brainstormState.loadingListImplementerIdeas || brainstormState.loadingListCollaboratorIdeas) && !this.isLoading) {
        this.loader = this.loadingCtrl.create({
          content: "Aguarde..."
        });
        this.loader.present();
        this.isLoading = true;
      }
      if (!brainstormState.loadingListImplementerIdeas && !brainstormState.loadingListCollaboratorIdeas && this.isLoading) {
        this.loader.dismiss();
        this.isLoading = false;
      }
      if (brainstormState.errorListImplementerIdeas || brainstormState.errorListCollaboratorIdeas) {
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao trazer as ideias cadastradas');
          }
        }, 200);
      }
      if (!this.collaboratorLoaded && brainstormState.loadingListCollaboratorIdeas == false && brainstormState.errorListCollaboratorIdeas == false && brainstormState.collaboratorIdeasData != null) {
        this.collaboratorLoaded = true;
        this.store.dispatch(new ListImplementerIdeasAction({ userId: this.userId }));
      }
      this.collaboratorItems = brainstormState.collaboratorIdeasData;
      this.implementerItems = brainstormState.implementerIdeasData;
      if (this.implementerItems != null && this.collaboratorItems != null) {
        if (this.refresher != null) {
          this.refresher.complete();
          this.refresher = null;
        }
        this.changeList(null);
      }
    });
    
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.brainstormSubscription != null) this.brainstormSubscription.unsubscribe();
  }

  refreshData(ref) {
    this.refresher = ref;
    this.collaboratorLoaded = false;
    this.store.dispatch(new ListCollaboratorIdeasAction({ userId: this.userId }));
  }

  itemTapped(event, item: IdeaModel) {
    this.store.dispatch(new IdeaClearAction());
    this.navCtrl.push(BrainstormPage, {
      id: item.id
    });
  }

  addIdea() {
    this.store.dispatch(new IdeaClearAction());
    this.navCtrl.push(BrainstormPage);
  }

  changeList(e) {
    if (this.selectedType == '0') {
      this.filteredItems = this.collaboratorItems;
    } else {
      this.filteredItems = this.implementerItems;
    }
  }

  search(e) {
    this.shouldShowCancelSearch = true;
    if (this.selectedType == '0') {
      this.filteredItems = this.collaboratorItems.filter(x => 
        x.identificacao.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0 || 
        x.ideia.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0);
    } else {
      this.filteredItems = this.implementerItems.filter(x => 
        x.identificacao.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0 || 
        x.ideia.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0);
    }
  }

  cancelSearch(e) {
    this.searchInput = '';
    this.shouldShowCancelSearch = false;
    if (this.selectedType == '0') {
      this.filteredItems = this.collaboratorItems;
    } else {
      this.filteredItems = this.implementerItems;
    }
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

  getColor(ideia: IdeaModel) {
    const todayDate = new Date();
    if (ideia.acao != null) {
      if (ideia.acao.ideiaAplicavel == null) {
				if (ideia.acao.prazoEstimado != null) {
          const prazo = new Date(ideia.acao.prazoEstimado);
          if (prazo < todayDate) {
						return 'attention';
					} else {
						return 'primary';
					}
				} else {
					return 'danger';
				}
			} else if (ideia.acao.ideiaAplicavel == true) {
				return 'secondary';
			} else if (ideia.acao.ideiaAplicavel == false) {
				return 'danger';
			}
    } else if (ideia.analise != null) {
      if (ideia.analise.prazoAnalise != null) {
				const prazoAnalise = new Date(ideia.analise.prazoAnalise);
				if (prazoAnalise < todayDate) {
					return 'attention';
				} else {
					return 'primary';
				}
			} else {
				return 'danger';
			}
    } else {
      return 'disabled';
    }
  }

  getDescription(ideia: IdeaModel) {
    const todayDate = new Date();
    if (ideia.acao != null) {
      if (ideia.acao.ideiaAplicavel == null) {
				if (ideia.acao.prazoEstimado != null) {
          const prazo = new Date(ideia.acao.prazoEstimado);
          if (prazo < todayDate) {
						return 'Atrasado na ação';
					} else {
						return 'Em Ação';
					}
				} else {
					return 'Reprovada na implementação';
				}
			} else if (ideia.acao.ideiaAplicavel == true) {
				return 'Concluida';
			} else if (ideia.acao.ideiaAplicavel == false) {
				return 'Reprovada no encerramento';
			}
    } else if (ideia.analise != null) {
      if (ideia.analise.prazoAnalise != null) {
        const prazoAnalise = new Date(ideia.analise.prazoAnalise);
				if (prazoAnalise < todayDate) {
					return 'Atrasado na implementação';
				} else {
					return 'Em implementação';
				}
			} else {
				return 'Reprovada após análise';
			}
    } else {
      return 'Em análise';
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/pages/brainstorm-list/brainstorm-list.ts